import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DataSourcesFileFormatList } from '../../lists/data-sources-file-format.list';
import { DataSourcesAdditionsComponent } from '../data-source-additions/data-sources-additions.component';
import { DataSourceUniqueNameComponent, DataSourceVisibilityComponent } from '../data-source-form-inputs';
import { DataSourcesBasic } from '../data-sources-basic';

@Component({
  selector: 'selfai-platform-data-sources-file',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,
    RadioButtonModule,
    TranslateModule,
    DataSourcesAdditionsComponent,
    DataSourceUniqueNameComponent,
    DataSourceVisibilityComponent,
  ],
  templateUrl: './data-sources-file.component.html',
  styleUrls: ['./data-sources-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSourcesFileComponent extends DataSourcesBasic implements OnInit {
  private readonly translate = inject(TranslateService);

  format = DataSourcesFileFormatList;
  separators = [
    { id: 'comma', labelTranslate: this.translate.instant('data-source.common.separator.comma') },
    { id: 'semicolon', labelTranslate: this.translate.instant('data-source.common.separator.semicolon') },
    { id: 'colon', labelTranslate: this.translate.instant('data-source.common.separator.colon') },
    { id: 'space', labelTranslate: this.translate.instant('data-source.common.separator.space') },
    { id: 'tab', labelTranslate: this.translate.instant('data-source.common.separator.tab') },
    { id: 'custom', labelTranslate: this.translate.instant('data-source.common.separator.custom') },
  ];

  paramsForm = this.fb.group({
    url: ['', Validators.required],
    fileFormat: ['csv'],
    csvFileFormatParams: this.fb.group({
      convert01ToBoolean: [false],
      includeHeader: [false],
      separatorType: ['comma'],
      customSeparator: [''],
    }),
  });

  constructor() {
    super('externalFile');
  }
}
